import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { loadClientDirectory } from "src/services/clientDirectory";
import type { FilterMultiSelectOption } from "./FilterMultiSelect";

/** Active clients of the current project for the overview client filter. */
export const useStatClients = (enabled: boolean, projectId: number | undefined) => {
	const [options, setOptions] = useState<FilterMultiSelectOption[]>([]);
	const [busy, setBusy] = useState(false);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		setOptions([]);
		setFailed(false);
		if (!enabled || !projectId) return;
		const controller = new AbortController();
		const logout = GD.S_AUTH_LOG_OUT.subscribe(() => controller.abort());
		setBusy(true);
		loadClientDirectory({ status: "active" }, { expectedProjectId: projectId, signal: controller.signal })
			.then(clients => {
				if (controller.signal.aborted) return;
				setOptions(clients
					.filter(client => client.status === "active")
					.map(client => ({ value: String(client.id), name: client.name?.trim() || `#${client.id}` }))
					.sort((a, b) => a.name.localeCompare(b.name)));
			})
			.catch(() => { if (!controller.signal.aborted) setFailed(true); })
			.finally(() => { if (!controller.signal.aborted) setBusy(false); });
		return () => { controller.abort(); GD.S_AUTH_LOG_OUT.unsubscribe(logout); };
	}, [enabled, projectId]);

	return { options, busy, failed };
};
